export const initialContext = {
    calendar: null,
    loading: false,
    error: null,
    fetchCalendar: () => {},
};
